//@flow
import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';
import ManageLines from './ManageLines';
import type { FlaggedProps } from './ManageLines';
import config from '../../config';
import { isLoadingSelector } from '../../modules/LoadingStatus/reducer';
import { fetchContracts } from '../../modules/LegalDocuments/Contracts/actions';

const mapStateToProps = state => ({
  isLoading: isLoadingSelector(state, 'fetchContracts'),
});

const mapDispatchToProps = {
  fetchContracts,
};

const withFlaggedProps = (): FlaggedProps => ({
  canTerminateLine: config.canTerminateLine,
  canWithdrawFromLine: config.canWithdrawFromLine,
  canGetRioNumber: config.canGetRioNumber,
  canChangePhoneNumber: config.canChangePhoneNumber,
  canCheckContract: config.canCheckContract,
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withProps(withFlaggedProps))(ManageLines);
